// [init]
import moment from 'moment';

export default {


	namespaced: true,

	state: {
		// Listing of all credits ( Array )
		creditsList: [],

		// Current credit being manipulated ( viewed or edited ) ( Object )
		status: ''
	},

	mutations: {

		// Add a Credit into CreditList
		addCredit( state, newCredit ) {
			state.creditsList.push( newCredit );
		},

		// Update CreditList with new list
		// @params: Array
		updateCreditList( state, newList ) {
			state.creditsList = newList.map(item => {
				item.total = item.total / 100;
				return item;
			});
		},

		// Change status of creditForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		}

	},

	actions: {
		
		/* 
		*  /GET Credits API
		*  Get all Credits from the server
		*  @return: Array
		*/
		getCredits( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/credits/list',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateCreditList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET Credits API CSV
		*  Get all Credits from the server as a CSV
		*  (different headers)
		*  @return: Array
		*/
		getCreditsCsv( { commit } ) {

			window.open( process.env.ENDPOINT + '/credits/download_csv_file' );

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}
	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Credits.js